<template>
    <div>
        <!-- Campo de búsqueda -->
        <s-text            
            autofocus
            :label="label"
            search-icon
            @clearable="clearable($event)"                  
            @keyupEnter="keyupEnter($event)"
            v-model="searchValue"
        >            
        </s-text>

        <!-- Modal para mostrar los datos del requerimiento -->
        <v-dialog v-model="dialog" max-width="1200px" persistent>
            <v-card>
                <s-toolbar 
                    color="primary" 
                    dark 
                    :label="'Requerimiento ' + (requirement.ReqDocumentNumber || '')" 
                    @close="closeDialog" 
                    close
                >
                </s-toolbar>
                
                <v-card-text v-if="requirement.ReqID">
                    <!-- Tipo de Requerimiento como Título -->
                    <v-container>
                        <v-row>
                            <v-col cols="12" class="text-center">
                                <h2 class="mb-4 primary--text">{{ requirement.TypeRequirementName }}</h2>
                            </v-col>
                        </v-row>

                        <!-- Cabecera del Requerimiento -->
                        <v-row>
                            <v-col cols="12" md="3">
                                <div class="mb-2">
                                    <strong>Número de Documento:</strong>
                                    <div>{{ requirement.ReqDocumentNumber }}</div>
                                </div>
                            </v-col>
                            <v-col cols="12" md="3">
                                <div class="mb-2">
                                    <strong>Usuario:</strong>
                                    <div>{{ requirement.UsrName }}</div>
                                </div>
                            </v-col>
                            <v-col cols="12" md="3">
                                <div class="mb-2">
                                    <strong>Área:</strong>
                                    <div>{{ requirement.AreName }}</div>
                                </div>
                            </v-col>
                            <v-col cols="12" md="3">
                                <div class="mb-2">
                                    <strong>Fecha:</strong>
                                    <div>{{ formatDate(requirement.ReqDate) }}</div>
                                </div>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="6">
                                <div class="mb-2">
                                    <strong>Estado:</strong>
                                    <div>{{ requirement.RqStatusName }}</div>
                                </div>
                            </v-col>
                            <v-col cols="12" md="6" v-if="requirement.ReqObservation">
                                <div class="mb-2">
                                    <strong>Observación:</strong>
                                    <div>{{ requirement.ReqObservation }}</div>
                                </div>
                            </v-col>
                        </v-row>

                        <v-divider class="my-4"></v-divider>

                        <!-- Detalle del Requerimiento -->
                        <v-row>
                            <v-col cols="12">
                                <h3 class="mb-3">Detalle - Seleccione los items</h3>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-data-table
                                    v-model="selectedDetails"
                                    :headers="headers"
                                    :items="requirement.Detail || []"
                                    :items-per-page="10"
                                    class="elevation-1"
                                    dense
                                    show-select
                                    item-key="DerID"
                                >
                                </v-data-table>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>

                <v-card-text v-else>
                    <v-container>
                        <v-row>
                            <v-col cols="12" class="text-center">
                                <p>No se encontraron datos para este requerimiento.</p>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn 
                        color="primary" 
                        @click="selectRequirement" 
                        v-if="requirement.ReqID && selectedDetails.length > 0"
                        :disabled="selectedDetails.length === 0"
                    >
                        Seleccionar ({{ selectedDetails.length }})
                    </v-btn>
                    <v-btn color="grey" text @click="closeDialog">
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import _sRequirement from "@/services/Logistics/RequirementService";

export default {
    name: "SSearchRequirement",
    props: {        
        label: { type: String, default: "Número de Requerimiento" },
    },
    data() {
        return {
            searchValue: "",
            dialog: false,
            requirement: {},
            selectedDetails: [],
            headers: [
                { text: "Línea", value: "DerNumLine" },
                { text: "Código", value: "ArtCode" },
                { text: "Descripción", value: "DerDescription" },
                { text: "Cantidad", value: "DerQuantity" },
                { text: "Unidad", value: "UnitMeasurement" },
                { text: "Centro de Costo", value: "CceName" },
                { text: "Línea de Negocio", value: "BslName" },
                { text: "Proyecto", value: "PrjName" },
                { text: "Observación", value: "DerObservation" },
            ],
        };
    },
    methods: {
        clearable() {
            this.searchValue = "";
            this.requirement = {};
            this.selectedDetails = [];
            this.$emit("clear");
        },
        
        formatDate(date) {
            if (!date) return "";
            const d = new Date(date);
            const day = String(d.getDate()).padStart(2, '0');
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const year = d.getFullYear();
            return `${day}/${month}/${year}`;
        },

        keyupEnter() {
            if (!this.searchValue || this.searchValue.trim() === "") {
                this.$fun.alert("Ingrese un número de requerimiento", "warning");
                return;
            }

            let searchParam = {};

            // Validar si es número
            const isNumeric = /^\d+$/.test(this.searchValue);

            if (isNumeric) {
                // Es solo números, se asume ReqID
                searchParam = {
                    ReqID: parseInt(this.searchValue),
                    ReqDocumentNumber: "" 
                };
            } else {
                // Tiene letras o caracteres, se asume ReqDocumentNumber
                searchParam = {
                    ReqID: 0,
                    ReqDocumentNumber: this.searchValue
                };
            }

            _sRequirement
                .byID(searchParam, this.$fun.getUserID())
                .then(resp => {
                    if (resp.status === 200) {
                        const data = resp.data;
                        console.log("Requerimiento encontrado:", data);
                        
                        if (data && data.ReqID) {
                            this.requirement = data;
                            this.selectedDetails = [];
                            this.dialog = true;
                            this.$emit("found", data);
                        } else {
                            this.$fun.alert("No se encontró el requerimiento", "warning");
                        }
                    }
                })
                .catch(error => {
                    console.error("Error al buscar requerimiento:", error);
                    this.$fun.alert("Error al buscar el requerimiento", "error");
                });
        },

        closeDialog() {
            this.dialog = false;
            this.selectedDetails = [];
        },

        selectRequirement() {
            if (this.selectedDetails.length === 0) {
                this.$fun.alert("Seleccione al menos un detalle", "warning");
                return;
            }
            
            this.$emit("select", {
                requirement: this.requirement,
                selectedDetails: this.selectedDetails
            });
            this.dialog = false;
            this.selectedDetails = [];
        }
    },    
}
</script>
